import IRootPageLink from '@/types/IRootPageLink';
import { FormControl, FormErrorMessage, FormLabel, Input, TabPanel } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface IAddServiceTabProps {
	form: UseFormReturn<IRootPageLink>;
}

export default function AddWebsiteTab(props: IAddServiceTabProps) {
	const { t } = useTranslation();

	return (
		<TabPanel>
			<FormControl mt="3" isInvalid={!!props.form.formState.errors.link}>
				<FormLabel>{t('Link')}</FormLabel>
				<Input
					{...props.form.register('link')}
					type="url"
					variant="filled"
					placeholder={t('Write any website URL here')}
				/>
				<FormErrorMessage>{props.form.formState.errors.link?.message}</FormErrorMessage>
			</FormControl>

			<FormControl mt="3">
				<FormLabel>{t('Visible text')}</FormLabel>
				<Input
					{...props.form.register('name')}
					type="text"
					variant="filled"
					placeholder={t('Write a visible text for your link here')}
				/>
			</FormControl>

			<FormControl mt="3">
				<FormLabel>{t('Description')}</FormLabel>
				<Input
					{...props.form.register('description')}
					variant="filled"
					placeholder={t('Write a description for your link here')}
				/>
			</FormControl>
		</TabPanel>
	);
}
